<template lang="pug">
.container.grid-lg.py-2
  load-manager(:status="status")
    div(v-if="current")
      show-analise(:analise="current")
      .no-print.my-2.py-2
        router-link.btn.btn-primary.mr-1(:to="{ name: 'app.analises.analises.show.trocarAnalista' }" v-if="current.situacao === 'aguardando'")
          btn-content(icon="fa fa-user-secret", label="Trocar analista")
        router-link.btn.btn-error.mr-1(:to="{ name: 'app.analises.analises.show.cancelar' }" v-if="current.situacao !== 'cancelado'")
          btn-content(icon="fa fa-times", label="Cancelar")
        a.btn.btn-link.btn-sm.no-print(
          onclick="window.print()"
        )
          i.fa.fa-print
          |  Imprimir
      router-view
</template>

<script>
import showMixin, { vuexDefaultMapping } from "@/mixins/show"
import ShowAnalise from "../ShowAnalise.vue"

export default {
  vuex: {
    "analises/analises": vuexDefaultMapping,
  },
  components: { ShowAnalise },

  mixins: [showMixin],
}
</script>
